import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import {
  getLoggedInUserRole,
  isPlatformSupportUser,
  isRouteAllowedForPlatformSupport,
  PLATFORM_SUPPORT_DEFAULT_ROUTE,
} from '../utils/user-role.util';

/**
 * Keeps a platform support user inside the pages that role is allowed to use
 * (menu pages and the restaurant profile). Any other `/main` child route —
 * including a pasted deep link — sends them back to the menu list.
 *
 * A route may also list the roles it is for in `data.roles` (e.g. Social
 * Media, FNF-1609); anyone else is sent to the dashboard.
 */
export const RoleGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  if (isPlatformSupportUser()) {
    const path = route.routeConfig?.path || '';
    if (isRouteAllowedForPlatformSupport(path)) {
      return true;
    }
    return router.createUrlTree(['main', PLATFORM_SUPPORT_DEFAULT_ROUTE]);
  }

  const roles: string[] | undefined = route.data?.['roles'];
  if (roles && !roles.includes(getLoggedInUserRole())) {
    return router.createUrlTree(['main', 'dashboard']);
  }
  return true;
};
